<script>
  import { IsNullOrEmpty } from '@/modules/helper/index'
    import { mapGetters } from 'vuex'
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      },
      multiLine: {
        type: Boolean,
        default: false
      },
      fieldType: {
        type: String,
        default: 'text' // text, email, phone, url
      },
      value: {
        type: String,
        default: '' // default
      },
      errorMessage: {
        type: String,
        default: '' // default
      }
    },
    computed: {
      ...mapGetters([
        'resource'
      ]),
      defaultValue: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('propChange', { value: value })
        }
      },
      IsNullOrEmptyErrorMessage() {
        if (this.required && !IsNullOrEmpty(this.value)) {
          return true
        }
      }
    },
    methods: {
      Clearinput () {
        this.$emit('propChange', { value: '' })
      }
    }
  }
</script>
<template>
  <f7-list class="inputs-list">
    <f7-list-item class="input-wrapper">
      <f7-label class="label-color">{{label}}</f7-label>
      <f7-input :class="'textinput'+$f7.theme" v-if="fieldType == 'text' && !multiLine" type="text" class="input-value-color" :value="defaultValue" @input="defaultValue = $event.target.value" :placeholder="placeholder" @input:clear="Clearinput"  :clear-button = "true"/>
      <f7-input :class="'textinput'+$f7.theme" v-if="fieldType == 'email'" type="email" class="input-value-color" :value="defaultValue" @input="defaultValue = $event.target.value" :placeholder="placeholder" @input:clear="Clearinput" :clear-button = "true"/>
      <f7-input :class="'textinput'+$f7.theme" v-if="fieldType == 'phone'" type="tel" class="input-value-color" :value="defaultValue" @input="defaultValue = $event.target.value" :placeholder="placeholder" @input:clear="Clearinput" :clear-button = "true"/>
      <f7-input :class="'textinput'+$f7.theme" v-if="fieldType == 'url'" type="url" class="input-value-color" :value="defaultValue" @input="defaultValue = $event.target.value" :placeholder="placeholder" @input:clear="Clearinput" :clear-button = "true"/>
      <f7-input :class="'textinput'+$f7.theme" ref="textareainput" type="textarea" v-if="fieldType == 'text' && multiLine" :value="defaultValue" validate :error-message="errorMessage" :error-message-force="!IsNullOrEmptyErrorMessage" clear-button
        @input="defaultValue = $event.target.value" :placeholder="placeholder"></f7-input>  
      <!-- <span v-if="errorMessage" class="color-red">{{errorMessage}}</span> -->
      <div v-if="!IsNullOrEmptyErrorMessage" class="color-red">{{errorMessage}}</div>
    </f7-list-item>
  </f7-list>
</template>
<style scoped>
  .list {
    margin: 15px 0;
  }
  .item-input-wrap >>> .input-with-value {
   width: 90vw;
  }
  .item-label {
    line-height: 15px !important;
  }
@media (max-width:767px) {
  .item-input-wrap >>> .input-with-value {
    width: 82vw;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/TextInput.vue